/**
 * @file store/user.ts
 * @description 用户状态管理模块，管理用户登录信息和 token
 */

import { defineStore } from 'pinia'

/**
 * 用户状态 Store
 * @description 管理用户认证信息，包括 token 和用户详情
 */
export const useUserStore = defineStore('user', {
    /**
     * 状态定义
     * @property token - 用户认证令牌，从sessionStorage 初始化
     * @property userInfo - 用户详细信息对象
     */
    state: () => ({
        token: sessionStorage.getItem('token') || '', // 从 sessionStorage 获取 token，用于页面刷新后保持登录状态
        userInfo: sessionStorage.getItem('dataMsg') ? JSON.parse(sessionStorage.getItem('dataMsg')) : {}, // 用户信息
    }),

    /**
     * 操作方法
     */
    actions: {
        /**
         * 设置用户 token
         * @param token - 用户认证令牌
         */
        setToken(token: string) {
            this.token = token
            sessionStorage.setItem('token', token) // 同步到 sessionStorage 持久化
        },

        /**
         * 清除用户 token 和登录信息
         * @description 用于用户退出登录时清空所有缓存数据
         */
        clearToken() {
            this.token = ''
            sessionStorage.clear() // 清空 sessionStorage 中所有数据
        },

        /**
         * 设置用户信息
         * @param info - 用户信息对象
         */
        setUserInfo(info: any) {
            this.userInfo = info
            sessionStorage.setItem('dataMsg', JSON.stringify(info)) // 序列化后存储到 sessionStorage
        }
    }
})
